"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({});
const dataSchema = zod_1.z.object({ value: zod_1.z.number().min(1).max(5) });
exports.default = new ItemDefinition_1.ItemDefinition("Rating", configSchema, dataSchema, new validation_1.ValidatorPipeline("Rating Config Validator", []), new validation_1.ValidatorPipeline("Rating Data Validator", []));
//# sourceMappingURL=Rating.js.map